import { useSelector } from "react-redux";
import { useGetUserPermissionQuery } from "../store/services/user";

export const useUserPermission = () => {
  const { auth } = useSelector((state) => state.auth);
  const { data } = useGetUserPermissionQuery(auth?._id);

  return data?.permissions || {};
};